export const MASTER_DIMENSIONS = [{
  id: 1,
  name: 'Master portrait',
  width: 400,
  height: 600,
},
{
  id: 2,
  name: 'Master landscape',
  width: 600,
  height: 400,
},
{
  id: 3,
  name: 'Master square',
  width: 400,
  height: 400,
}];
// TODO remove this as we have real data, update unit test
export const DISPLAY_DIMENSIONS = [
  {
    id: 1,
    name: 'Small Square',
    width: 200,
    height: 200,
    masterId: 3,
    isEnabled: true,

  },
  {
    id: 2,
    name: 'Vertical Rectangle',
    width: 240,
    height: 400,
    masterId: 2,
    isEnabled: true,

  },
  {
    id: 3,
    name: 'Square',
    width: 250,
    height: 250,
    masterId: 3,
    isEnabled: true,

  },
  {
    id: 4,
    name: 'Triple Widescreen',
    width: 250,
    height: 360,
    masterId: 2,
    isEnabled: true,

  },
  {
    id: 5,
    name: 'Inline Rectangle',
    width: 300,
    height: 250,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 6,
    name: 'Large Rectangle',
    width: 336,
    height: 280,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 7,
    name: 'Netboard',
    width: 580,
    height: 400,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 8,
    name: 'Skyscraper',
    width: 120,
    height: 600,
    masterId: 2,
    isEnabled: true,

  },
  {
    id: 9,
    name: 'Wide Skyscraper',
    width: 160,
    height: 600,
    masterId: 2,
    isEnabled: true,

  },
  {
    id: 10,
    name: 'Half Page',
    width: 300,
    height: 600,
    masterId: 2,
    isEnabled: true,

  },
  {
    id: 11,
    name: 'Portrait',
    width: 300,
    height: 1050,
    masterId: 2,
    isEnabled: true,

  },
  {
    id: 12,
    name: 'Main Banner',
    width: 468,
    height: 60,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 13,
    name: 'Leaderboard',
    width: 728,
    height: 90,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 14,
    name: 'Top Banner',
    width: 930,
    height: 180,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 15,
    name: 'Large Leaderboard',
    width: 970,
    height: 90,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 16,
    name: 'Billboard',
    width: 970,
    height: 250,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 17,
    name: 'Panorama',
    width: 980,
    height: 120,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 18,
    name: 'Mobile Banner',
    width: 300,
    height: 50,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 19,
    name: 'Mobile Leaderboard',
    width: 320,
    height: 50,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 20,
    name: 'Large Mobile',
    width: 320,
    height: 100,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 21,
    name: 'Half Banner',
    width: 234,
    height: 60,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 22,
    name: 'Vertical Banner',
    width: 120,
    height: 240,
    masterId: 2,
    isEnabled: true,

  },
  {
    id: 23,
    name: 'Small Rectangle',
    width: 180,
    height: 150,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 24,
    name: 'Responsive Landscape Art',
    width: 1200,
    height: 628,
    masterId: 1,
    isEnabled: true,

  },
  {
    id: 25,
    name: 'Responsive Square Art',
    width: 1200,
    height: 1200,
    masterId: 3,
    isEnabled: true,

  },
];

export const FACEBOOK_DIMENSIONS = [
  {
    id: 15,
    name: '1080x1350',
    width: 1080,
    height: 1350,
    masterId: 1,
    isEnabled: true,
  },
  {
    id: 17,
    name: '1200x628',
    width: 1200,
    height: 628,
    masterId: 2,
    isEnabled: true,
  },
  {
    id: 18,
    name: '1920x1080',
    width: 1920,
    height: 1080,
    masterId: 2,
    isEnabled: true,
  },
];

export const GOOGLE_DIMENSIONS = [
  {
    id: 2,
    name: '300x50',
    width: 300,
    height: 50,
    masterId: 2,
    isEnabled: true,
  },
  {
    id: 3,
    name: '300x250',
    width: 300,
    height: 250,
    masterId: 2,
    isEnabled: true,
  },
  {
    id: 4,
    name: '300x600',
    width: 300,
    height: 600,
    masterId: 1,
    isEnabled: true,
  },
  {
    id: 5,
    name: '320x50',
    width: 320,
    height: 50,
    masterId: 2,
    isEnabled: true,
  },
  {
    id: 6,
    name: '320x100',
    width: 320,
    height: 100,
    masterId: 2,
    isEnabled: true,
  },
  {
    id: 7,
    name: '320x480',
    width: 320,
    height: 480,
    masterId: 1,
    isEnabled: true,
  },
  {
    id: 8,
    name: '480x320',
    width: 480,
    height: 320,
    masterId: 2,
    isEnabled: true,
  },
  {
    id: 9,
    name: '728x90',
    width: 728,
    height: 90,
    masterId: 2,
    isEnabled: true,
  },
  {
    id: 10,
    name: '768x1024',
    width: 768,
    height: 1024,
    masterId: 1,
    isEnabled: true,
  },
  {
    id: 13,
    name: '1024x768',
    width: 1024,
    height: 768,
    masterId: 2,
    isEnabled: true,
  },
  {
    id: 14,
    name: '1080x1080',
    width: 1080,
    height: 1080,
    masterId: 3,
    isEnabled: true,
  },
];

export const SNAPCHAT_DIMENSIONS = [
  {
    id: 18,
    name: '1080x1920',
    width: 1080,
    height: 1920,
    masterId: 1,
    isEnabled: true,
  },
];

export const PINTEREST_DIMENSIONS = [
  {
    id: 12,
    name: '1000x1500',
    width: 1000,
    height: 1500,
    masterId: null,
    isEnabled: true,
  },
];

export const INSTAGRAM_DIMENSIONS = [
  {
    id: 14,
    name: '1080x1080',
    width: 1080,
    height: 1080,
    masterId: 3,
    isEnabled: true,
  },
  {
    id: 15,
    name: '1080x1350',
    width: 1080,
    height: 1350,
    masterId: 1,
    isEnabled: true,
  },
];

export const TWITTER_DIMENSIONS = [
  {
    id: 11,
    name: '1000x500',
    width: 1000,
    height: 500,
    masterId: 2,
    isEnabled: true,
  },
  {
    id: 14,
    name: '1080x1080',
    width: 1080,
    height: 1080,
    masterId: 3,
    isEnabled: true,
  },
  {
    id: 17,
    name: '1200x628',
    width: 1200,
    height: 628,
    masterId: 2,
    isEnabled: true,
  },
];
